export const MEDIA_MAX_SIZE = { width: 680, height: 400 };
export const MEDIA_PREVIEW_MAX_SIZE = { width: 680, height: 400 };
